import './messageContainer.scss';

import PropTypes from 'prop-types';
import { Message, PartnerMessage } from '@bwoty-web/ui-kit';

const MessageContainer = (props) => {
  const { message, user, upsellMessage, labels, style } = props;

  const messages = [];

  if (message && (message.title || message.message)) {
    if (message.severity?.toUpperCase() === 'ERROR') {
      messages.push(
        <Message
          header={message.title}
          messageType="error"
          initiallyExpanded
          key={1}
        >
          {message.message}
        </Message>,
      );
    } else if (message.severity?.toUpperCase() === 'WARNING') {
      messages.push(
        <Message
          header={message.title}
          messageType="alert"
          initiallyExpanded
          key={1}
        >
          {message.message}
        </Message>,
      );
    } else if (message.severity?.toUpperCase() === 'INFORMATION') {
      messages.push(
        <Message
          header={message.title}
          messageType="info"
          initiallyExpanded
          key={1}
        >
          {message.message}
        </Message>,
      );
    }
  }

  if (user.toUpperCase() === 'Z11') {
    messages.push(
      <PartnerMessage header={labels.icaBanner} partner="ica" key={0} />,
    );
  }

  if (user.toUpperCase() === 'Z40') {
    messages.push(
      <PartnerMessage header={labels.plussaBanner} partner="plussa" key={0} />,
    );
  }

  if (upsellMessage && (upsellMessage.title || upsellMessage.message)) {
    messages.push(
      <Message
        header={upsellMessage.title}
        messageType="info"
        initiallyExpanded
        key={2}
      >
        {upsellMessage.message}
      </Message>,
    );
  }

  if (messages.length === 0) {
    return null;
  }

  return (
    <div className="iw-message-container" style={style}>
      {messages}
    </div>
  );
};

MessageContainer.propTypes = {
  user: PropTypes.string,
  message: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
    severity: PropTypes.string,
  }),
  labels: PropTypes.shape({
    plussaBanner: PropTypes.string,
    icaBanner: PropTypes.string,
  }),
  upsellMessage: PropTypes.shape({
    title: PropTypes.string,
    message: PropTypes.string,
  }),
  style: PropTypes.shape(),
};

MessageContainer.defaultProps = {
  message: null,
  labels: null,
  upsellMessage: null,
  user: '-1',
  style: null,
};

export default MessageContainer;
